let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lrZzd")).then(() => parcelRequire('9ZIo7'));